import fgInput from './components/Inputs/formGroupInput.vue'
import DropDown from './components/Dropdown.vue'
import Card from './components/Cards/Card.vue'
import InfoModal from './components/Modal/InfoModal.vue'
import {Input, InputNumber, ColorPicker} from 'element-ui'
import { ToggleButton } from 'vue-js-toggle-button'
import VueToggles from 'vue-toggles';
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component('VueToggles', VueToggles)
    Vue.component('fg-input', fgInput)
    Vue.component('drop-down', DropDown)
    Vue.component('card', Card)
    Vue.component('info-modal', InfoModal)
    Vue.component(Input.name, Input)
    Vue.component(InputNumber.name, InputNumber)
    Vue.component(ColorPicker.name, ColorPicker)
    Vue.component('ToggleButton', ToggleButton)
  }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js